import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { Merchants } from "ui/organizms/Merchants";

const MerchantsScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Merchants | General'
    >
        <Merchants />
    </Screen>
);

export default memo(MerchantsScreen);
